import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/menus" element={<DefaultConsumerLayout />}>
    <Route path="consumer/menus" element={<AsyncPage />} />
  </Route>
);
